import { AppMenu } from "@/components/layout/AppMenu";
import { cn } from "@/lib/cn";
import type { ReactNode } from "react";

interface AppLayoutProps {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  tone?: "surface" | "grid";
}

export function AppLayout({
  children,
  className,
  contentClassName,
  tone = "surface",
}: AppLayoutProps) {
  return (
    <div
      className={cn(
        "relative min-h-dvh",
        tone === "grid" ? "grid-bg" : "bg-[var(--color-surface-muted)]",
        className,
      )}
    >
      <div className="standalone-safe-top fixed right-4 top-4 z-30 sm:right-6 sm:top-6">
        <AppMenu floating />
      </div>
      <div className={cn("min-w-0 pt-12 sm:pt-14 lg:pt-16", contentClassName)}>{children}</div>
    </div>
  );
}
